module.exports = __webpack_public_path__ + "img/work_stopped.84240c8e.svg";